<template>
  <div>
    <el-table
      :border="true"
      :data="rows"
      @sort-change="doChangeSort"
      ref="table"
      row-key="id"
      v-loading="loading"
    >
      <el-table-column type="selection" width="55"></el-table-column>

      <el-table-column v-if="hasPermissionToAuditLogs" :label="fields.id.label"  :prop="fields.id.name" sortable="custom">
        <template slot-scope="scope">{{ presenter(scope.row, 'id') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.title.label"
        :prop="fields.title.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'title') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.description.label"
        :prop="fields.description.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'description') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.date.label"
        :prop="fields.date.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'date') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.hour.label"
        :prop="fields.hour.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'hour') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.duration.label"
        :prop="fields.duration.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'duration') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.location.label"
        :prop="fields.location.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'location') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.status.label"
        :prop="fields.status.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'status') }}</template>
      </el-table-column>

      <el-table-column :label="fields.team.label" :prop="fields.team.name">
        <template slot-scope="scope">
          <app-list-item-relation-to-one
            :label="fields.team.label"
            :permission="fields.team.readPermission"
            :url="fields.team.viewUrl"
            :value="presenter(scope.row, 'team')"
          ></app-list-item-relation-to-one>
        </template>
      </el-table-column>

      <el-table-column
        :label="fields.createdAt.label"
        :prop="fields.createdAt.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'createdAt') }}</template>
      </el-table-column>

      <el-table-column :fixed="isMobile? undefined : 'right'" align="center" width="180">
        <template slot-scope="scope">
          <div class="table-actions">
            <router-link :to="`/training/${scope.row.id}`">
              <el-button type="text">
                <app-i18n code="common.view"></app-i18n>
              </el-button>
            </router-link>

            <router-link :to="`/training/${scope.row.id}/edit`" v-if="hasPermissionToEdit">
              <el-button type="text">
                <app-i18n code="common.edit"></app-i18n>
              </el-button>
            </router-link>

            <el-button
              :disabled="destroyLoading"
              @click="doDestroyWithConfirm(scope.row.id)"
              type="text"
              v-if="hasPermissionToDestroy"
            >
              <app-i18n code="common.destroy"></app-i18n>
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="el-pagination-wrapper">
      <el-pagination
        :current-page="pagination.currentPage || 1"
        :disabled="loading"
        :layout="paginationLayout"
        :total="count"
        @current-change="doChangePaginationCurrentPage"
        @size-change="doChangePaginationPageSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { TrainingModel } from '@modules/training/training-model';
import { mapGetters, mapActions } from 'vuex';
import { TrainingPermissions } from '@modules/training/training-permissions';
import { i18n } from '@shared/i18n';

const { fields } = TrainingModel;

export default {
  name: 'app-training-list-table',

  mounted() {
    this.doMountTable(this.$refs.table);
  },

  computed: {
    ...mapGetters({
      rows: 'training/list/rows',
      count: 'training/list/count',
      loading: 'training/list/loading',
      pagination: 'training/list/pagination',
      isMobile: 'layout/isMobile',
      currentUser: 'auth/currentUser',
      destroyLoading: 'training/destroy/loading',
      paginationLayout: 'layout/paginationLayout',
    }),

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    hasPermissionToEdit() {
      return new TrainingPermissions(this.currentUser).edit;
    },

    hasPermissionToDestroy() {
      return new TrainingPermissions(this.currentUser).destroy;
    },

    fields() {
      return fields;
    },
  },

  methods: {
    ...mapActions({
      doChangeSort: 'training/list/doChangeSort',
      doChangePaginationCurrentPage:
        'training/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize:
        'training/list/doChangePaginationPageSize',
      doMountTable: 'training/list/doMountTable',
      doDestroy: 'training/destroy/doDestroy',
    }),

    presenter(row, fieldName) {
      return TrainingModel.presenter(row, fieldName);
    },

    async doDestroyWithConfirm(id) {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );

        return this.doDestroy(id);
      } catch (error) {
        // no
      }
    },
  },
};
</script>

<style>
</style>
